import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@coin/shared/auth/data-access';

@Component({
  selector: 'coin-siemens-energy-logout-screen',
  templateUrl: './logout-screen.component.html',
  styleUrls: ['./logout-screen.component.scss'],
  standalone: false
})
export class LogoutScreenComponent implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthService);

  ngOnInit(): void {
    this.authService.logOff();
  }

  login(): void {
    this.router.navigate(['/']);
  }
}
